import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../assets/css/Blogs.css";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";


const PAGE_SIZE = 9;

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/blogs`);
      setBlogs(response.data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  // Filter: only show blogs of category "Donation"
  const filteredBlogs = blogs.filter((blog) => blog.category === "Donation");

  const totalPages = Math.max(1, Math.ceil(filteredBlogs.length / PAGE_SIZE));
  const visibleItems = filteredBlogs.slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  const handlePage = (p) => {
    if (p < 1 || p > totalPages) return;
    setPage(p);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <BreadcrumbSection
        title="Donation Blogs"
        breadcrumbItems={[{ label: "Home", to: "/" }]}
        backgroundImage={BredcrumpImage}
      />

      <section className="blogs-page">
        {/* <div className="blogs-header container">
          <div className="page-title ">
            <h2 >Donation Blogs</h2>
            <div className="underline" />
          </div>

        </div> */}

        <div className="container cards-grid">
          <div className="grid-row">
            {visibleItems.slice(0, 3).map((item) => (
              <article
                key={item._id}
                className="blog-card"
                onClick={() => navigate(`/blog/${item._id}`)}
                style={{ cursor: "pointer" }}
              >
                <div className="thumb">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/uploads/${item.image}`}
                    alt={item.title}
                    loading="lazy"
                  />
                </div>
                <div className="card-body">
                  <div className="meta">
                    <span className="meta-cat">{item.category}</span>
                    <span className="meta-date">
                      {new Date(item.createdAt).toDateString()}
                    </span>
                  </div>
                  <h3 className="title">{item.title}</h3>
                  <p className="excerpt">
                    {item.description.slice(0, 100)}...
                  </p>
                  <span className="read-more">Read More...</span>
                </div>
              </article>
            ))}
          </div>

          {visibleItems.length >= 6 && (
            <div className="highlight-row">
              <div className="grid-row">
                {visibleItems.slice(3, 6).map((item) => (
                  <article
                    key={item._id}
                    className="blog-card"
                    onClick={() => navigate(`/blog/${item._id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="thumb">
                      <img
                        src={`${process.env.REACT_APP_API_URL}/uploads/${item.image}`}
                        alt={item.title}
                        loading="lazy"
                      />
                    </div>
                    <div className="card-body">
                      <div className="meta">
                        <span className="meta-cat">{item.category}</span>
                        <span className="meta-date">
                          {new Date(item.createdAt).toDateString()}
                        </span>
                      </div>
                      <h3 className="title">{item.title}</h3>
                      <p className="excerpt">
                        {item.description.slice(0, 100)}...
                      </p>
                      <span className="read-more">Read More...</span>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          )}

          <div className="grid-row">
            {visibleItems.slice(6, 9).map((item) => (
              <article
                key={item._id}
                className="blog-card"
                onClick={() => navigate(`/blog/${item._id}`)}
                style={{ cursor: "pointer" }}
              >
                <div className="thumb">
                  <img
                    src={`${process.env.REACT_APP_API_URL}/uploads/${item.image}`}
                    alt={item.title}
                    loading="lazy"
                  />
                </div>
                <div className="card-body">
                  <div className="meta">
                    <span className="meta-cat">{item.category}</span>
                    <span className="meta-date">
                      {new Date(item.createdAt).toDateString()}
                    </span>
                  </div>
                  <h3 className="title">{item.title}</h3>
                  <p className="excerpt">
                    {item.description.slice(0, 100)}...
                  </p>
                  <span className="read-more">Read More...</span>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="container pagination-row">
          <div className="pagination">
            <button
              className="page-btn"
              onClick={() => handlePage(page - 1)}
              disabled={page === 1}
            >
              &lt;
            </button>

            {[...Array(totalPages)].map((_, idx) => {
              const p = idx + 1;
              return (
                <button
                  key={p}
                  className={`page-number ${p === page ? "active" : ""}`}
                  onClick={() => handlePage(p)}
                >
                  {p}
                </button>
              );
            })}

            <button
              className="page-btn"
              onClick={() => handlePage(page + 1)}
              disabled={page === totalPages}
            >
              &gt;
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
